import React, { useRef, useLayoutEffect, useEffect } from 'react'
import { motion, useIsPresent } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Navbar from '../components/Navbar'
import SubKv from '../components/SubKv'
import Outro from '../components/Outro'
import Banner from '../components/Banner';
import SubHeader from '../components/SubHeader';
import { bannerLounge, bannerPrivateroom } from "../assets/data/bannerData"

import { lobbyKvData, lobbyData } from "../assets/data/subData";
import lobbyMainCalliPC from "../assets/images/lobby/lobby_calli_main-pc.png";
import lobbyMainCalliTab from "../assets/images/lobby/lobby_calli_main-tab.png";
import lobbyCalli from "../assets/images/lobby/lobby_calli-pc.png";

gsap.registerPlugin(ScrollTrigger);


export function Lobby() {
  

  const isPresent = useIsPresent();

  const lobby = useRef();
  const containerWrap = useRef();
  const loobyGalleryContainer = useRef([]);
  const loobyGallery = useRef([]);
  const article = useRef([]);
  const conceptTitle = useRef([]);
  const conceptDesc = useRef([]);
  const conceptImg = useRef([]);
  const conceptIndex = useRef([]);
  const galleryContents = useRef([]);

  const galleryItem = useRef([
    ['', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['', '', '', '', '', '']]);


  useEffect(() => {
    let mm = gsap.matchMedia(), breakPoint = 1024;
    let horizontalScroll;

    // PC 이상일 경우, 갤러리 가로 스크롤
    mm.add(`(min-width: ${breakPoint}px)`, () => {
      loobyGallery.current[0] && loobyGallery.current.map((place, i) => (

        horizontalScroll = gsap.fromTo(place,
          { x: '12.5vw' },
          { x: `-51vw`,

            scrollTrigger: {
              trigger: loobyGalleryContainer.current[i],
              start: "top top",
              end: "bottom bottom",
              scrub: true,
              scroller: containerWrap.current,
            },
          })
      ))
    })

    // Tab 이하일 경우, 갤러리 transform 초기화
    mm.add(`(max-width: ${breakPoint - 1}px)`, () => {
      loobyGallery.current[0] && loobyGallery.current.map((place) => (
        horizontalScroll = gsap.set(place, { x: `0` })
      ))
    })

    return () => (
      horizontalScroll.kill()
    )
  }, [])

  //  Tab 이하일 경우, 텍스트 & 이미지 등장 효과
  const observer = useRef(
    new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('on');
          } else {
            entry.target.classList.remove('on');
          }
        });
      }, { threshold: 0.1 }
    )
  );


  useEffect(() => {
    for (let i = 0; i < conceptDesc.current.length; i++) {
      observer.current.observe(conceptTitle.current[i])
      observer.current.observe(conceptDesc.current[i])
      observer.current.observe(conceptImg.current[i])
      observer.current.observe(conceptIndex.current[i])
      observer.current.observe(galleryContents.current[i])

      for (let j = 0; j < galleryItem.current[i].length; j++) {
        observer.current.observe(galleryItem.current[i][j]);
      }
    }
  }, [window.innerWidth]);


  // 아티클이 넘어가면 그라데이션
  useEffect(() => {

    article.current.map((place, idx) => (

      gsap.fromTo(lobby.current,
        { backgroundColor: `var(--lobby-bg${idx})` },
        { backgroundColor: `var(--lobby-bg${idx + 1})`,

          scrollTrigger: {
            trigger: place,
            start: "top 55%",
            end: "top 45%",
            scrub: true,
            scroller: containerWrap.current,
          },
        })
    ))

    gsap.set(lobby.current, { backgroundColor: `var(--lobby-bg0)` });

  }, [])


  
  return (
    <div className="container">
      <div className="container_wrap" ref={containerWrap}>
        
        <Navbar />
        <SubHeader title={lobbyKvData.title} class={lobbyKvData.class} content={containerWrap.current} />
        <SubKv title={lobbyKvData.title} img={lobbyKvData.img} class={lobbyKvData.class} />
        <section id="LOBBY" ref={lobby} className="contents lobby">
          {lobbyData?.map((place, idx) => (

            <article key={idx} ref={el => article.current[idx] = el}>
              <div className="lobby__container">
                <div className="lobby__inner">

                  <div className="lobby-concept">

                    <div className="concept__side_bg">
                      <span className="side__calli">
                        <picture>
                          <source media="(min-width: 1024px)" srcSet={lobbyMainCalliPC} />
                          <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={lobbyMainCalliTab} />
                          <source media="(min-width: 0px) and (max-width: 767px)" srcSet={lobbyMainCalliTab} />
                          <img src={lobbyMainCalliPC} alt="" />
                        </picture>

                      </span>
                    </div>

                    <div className="concept__wrap">
                      <div className="concept__contents">

                        <div className="concept__txt__wrap">
                          <div className="concept__txt">
                            <span className="index"
                              ref={el => conceptIndex.current[idx] = el}
                            ><strong>LOBBY 0{idx + 1}</strong> / 03</span>
                            <h1 className="title"
                              ref={el => conceptTitle.current[idx] = el}
                            >
                              <picture>
                                <img src={place.titleImg} alt={place.title} />
                              </picture>
                            </h1>
                            <p className="desc"
                              ref={el => conceptDesc.current[idx] = el}
                            >{place.mainDesc}</p>
                          </div>
                        </div>

                        <div className="concept__img"
                          ref={el => conceptImg.current[idx] = el}>
                          <picture>
                            <source media="(min-width: 1024px)" srcSet={place.mainImg.pcSrc} />
                            <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={place.mainImg.tabSrc} />
                            <source media="(min-width: 0px) and (max-width: 767px)" srcSet={place.mainImg.moSrc} />
                            <img src={place.mainImg.pcSrc} alt={place.mainImg.alt} />
                          </picture>
                        </div>
                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div className="lobby__container " ref={el => loobyGalleryContainer.current[idx] = el}>
                <div className="lobby__inner">

                  <div className="lobby-gallery">
                    <div className="gallery__wrap">

                      <div className="gallery__contents" ref={el => galleryContents.current[idx] = el}>

                        <div className="gallery__txt">
                          <span className="side__calli"><img src={lobbyCalli} alt="closetMain" width={124} height={40} /></span>
                          <p className="gallery__desc gowun-batang-regular">{place.detailDesc}</p>
                        </div>

                        <ul className="gallery__list" ref={el => loobyGallery.current[idx] = el}>

                          {place.detailImgs.map((img, imgIdx) => (
                            <li className="gallery__item" key={imgIdx}
                              ref={el => galleryItem.current[idx][imgIdx] = el}>
                              <picture>
                                <source media="(min-width: 1024px)" srcSet={img.pcSrc} />
                                <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={img.tabSrc} />
                                <source media="(min-width: 0px) and (max-width: 767px)" srcSet={img.moSrc} />
                                <img src={img.pcSrc} alt={img.alt} />
                              </picture>
                            </li>
                          ))}
                        </ul>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </article>

          ))}


          <Outro />

          <Banner
            classType={bannerLounge.classType}
            title={bannerLounge.title}
            titleSrcPc={bannerLounge.titleSrcPc}
            titleSrcTab={bannerLounge.titleSrcTab}
            titleSrcMo={bannerLounge.titleSrcMo}
            unionSrc={bannerLounge.unionSrc}
            description1={bannerLounge.description1}
            description2={bannerLounge.description2}
            linkDesc={bannerLounge.linkDesc}
            link={bannerLounge.link}
          />
          <Banner
            classType={bannerPrivateroom.classType}
            title={bannerPrivateroom.title}
            titleSrcPc={bannerPrivateroom.titleSrcPc}
            titleSrcTab={bannerPrivateroom.titleSrcTab}
            titleSrcMo={bannerPrivateroom.titleSrcMo}
            unionSrc={bannerPrivateroom.unionSrc}
            description1={bannerPrivateroom.description1}
            description2={bannerPrivateroom.description2}
            linkDesc={bannerPrivateroom.linkDesc}
            link={bannerPrivateroom.link}
          />

          {/* (s) 페이지 전환 애니메이션 */}
          <motion.div
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut" } }}
            exit={{ scaleY: 1, transition: { duration: 0.5, ease: "circIn" } }}
            style={{ originY: isPresent ? 0 : 1 }}
            className="transition-screen-step1"
          />
          <motion.div
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut", delay: 0.1 } }}
            exit={{ scaleY: 1, transition: { duration: 0.5, ease: "circIn", delay: 0.1 } }}
            style={{ originY: isPresent ? 0 : 1 }}
            className="transition-screen-step2"
          />
          {/* (e) 페이지 전환 애니메이션 */}
        </section>
      </div>
    </div>
  )
}